import { Box } from '@material-ui/core';
import { Loan } from '@nemuru-eng/js-api-client';

import { LoanApplicationCard } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationCard';
import { LoanApplicationMode } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/types/LoanApplicationMode';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { Text } from '@/components/shared/components/Text';
import { useTranslation } from '@/components/shared/hooks/useTranslation';

interface MerchantChannelAgentLoanApplicationsProps {
  loan: Loan;
  mode: LoanApplicationMode;
}

export const MerchantChannelAgentLoanApplications = ({ loan, mode }: MerchantChannelAgentLoanApplicationsProps) => {
  const { getTextIdTranslation } = useTranslation();

  if (!loan.loanApplicationSelected) return <PendingDataWarning />;

  const lenderName = loan.loanApplicationSelected.lenderName;
  const lenderApprovalStatus = loan.loanApplicationSelected.lenderFields.loanApplicationStatus.lenderApprovalStatus;
  const approvalStatusTranslation = getTextIdTranslation(lenderApprovalStatus as string);

  const cardTooltip = (
    <>
      <Box mb={2}>
        <strong>
          <Text tId={'SELECTED_LENDER'} />
        </strong>
      </Box>
      <Box>
        {lenderApprovalStatus ? (
          <>
            <Text
              tId={'LENDER_X_ANSWERED_X_TO_APPLICATION'}
              dynamicDataTexts={[lenderName || '', `${approvalStatusTranslation}`]}
            />
          </>
        ) : (
          <Text tId={'LENDER_IS_PROCESSING_THE_APPLICATION'} />
        )}
      </Box>
    </>
  );

  return (
    <StyledTooltip title={cardTooltip} tooltipProps={{ enterDelay: 500 }}>
      <LoanApplicationCard
        onClick={() => {}}
        mode={mode}
        lenderApprovalStatus={lenderApprovalStatus}
        isSelected={true}
        lenderName={lenderName}
        merchantChannelAgentViewMode
      />
    </StyledTooltip>
  );
};
